import React, {Component} from 'react';
import moment from 'moment';
import {connect} from 'react-redux';
import DatePicker from 'react-datepicker';
import {Card, Header, Form, Input, Button, Dropdown} from 'semantic-ui-react';
import {reverseShortDate} from '../../../common/constants/datesFormat';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import Loader from '../../../common/components/loader';
import './styles.scss';
class ReportPartsSalesJapan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'start': moment().startOf('month').format(reverseShortDate),
      'end': moment().format(reverseShortDate),
      'providerTmp': 'all',
      'providerSelected': 'all',
    };
  }
  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PartsSalesJapan,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.loadProviders({'withOrigin': true});
    this.handleSearch();
  }
  handledDowloadReport = () => {
    const {start, end} = this.state;
    this.props.getCombosReportDataExcel(start, end);
  };
  handleChange = (field, value) => {
    this.setState({
      [field]: moment(value).format(reverseShortDate),
    });
  };
  handleSearch = () => {
    const {start, providerSelected} = this.state;
    console.log(start, providerSelected);
    let newDate = start.replace(/\//g, '-');
    this.props.getSalesDataTxt(newDate, providerSelected, 'R');
    // this.props.getCombosReportData(start, end);
  };
  updateProviderFilter(value) {
    this.setState({'providerTmp': value}, () => this.updateDataForProvider());
  }
  getProviders() {
    const dealers = this.props.providers.map((dealer) => {
      return {'text': dealer.name, 'value': dealer.code};
    });
    dealers.unshift({'text': 'Todos los proveedores', 'value': 'all'});
    return dealers;
  }
  updateDataForProvider() {
    const {providerSelected, providerTmp} = this.state;
    if (providerSelected === providerTmp) {
      return;
    }
    this.setState({'providerSelected': providerTmp});
  }
  render() {
    const {start, end} = this.state;
    const {loading} = this.props;
    const {providerTmp} = this.state;
    if (loading) {
      return <Loader />;
    }
    return (
      <div>
        <Card raised fluid className='container-report-combos'>
          <div className='container-report-combos-header'>
            <Header as='h2'>Reporte Venta de Partes Japón</Header>
            <div className='container-report-combos-controls'>
              <Form.Field className='report-combos-label'>
                <label>Proveedor</label>
                <Dropdown
                  selection
                  fluid
                  options={this.getProviders()}
                  search
                  value={providerTmp}
                  onChange={(e, {value}) => this.updateProviderFilter(value)}
                  placeholder='Seleccionar'
                  noResultsMessage='Proveedor no encontrado'
                />
              </Form.Field>
              <Form.Input
                fluid
                label='Fecha Inicial'
                className='report-combos-label'
              >
                <DatePicker
                  customInput={<Input icon='calendar' size='small' />}
                  placeholderText='mm/yyyy'
                  className='report-combos-datepicker'
                  selected={
                    start ? moment(start, reverseShortDate).toDate() : null
                  }
                  maxDate={moment(end, reverseShortDate).toDate()}
                  dateFormat='MM-yyyy'
                  showMonthYearPicker
                  onChange={(value) => this.handleChange('start', value)}
                  locale='es'
                />
              </Form.Input>
              <div className='report-combos-btn'>
                <Button onClick={this.handleSearch} color='blue'>
                Descargar TXT
                </Button>
              </div>
            </div>
          </div>
        </Card>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'loading': state.reportPartsSalesJapanData.loading,
    'data': state.reportPartsSalesJapanData.data,
    'providers': state.provider.list,
  };
};
const {navigateTo, getSalesDataTxt, getCombosReportDataExcel, loadProviders} = Actions;
export default connect(mapStateToProps, {
  navigateTo,
  getSalesDataTxt,
  getCombosReportDataExcel,
  loadProviders,
})(ReportPartsSalesJapan);
